import styled from "@emotion/styled";

const StyledScrollableContainer = styled("div")`
  overflow: auto;
  min-height: 0;
`;

export default StyledScrollableContainer;
